import { render } from "./NameTips.vue?vue&type=template&id=33cb1e84"
import script from "./NameTips.vue?vue&type=script&lang=js"
export * from "./NameTips.vue?vue&type=script&lang=js"

import "./NameTips.vue?vue&type=style&index=0&id=33cb1e84&lang=scss"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__